module.exports = __webpack_public_path__ + "static/media/cherlynn-stevens.e87496fa.md";